import moment from 'moment-timezone';

import config from '../../config';
import {UserInfoV2Response,UserV2} from '../types/user.type';

export const transformUserV2 = (data: UserInfoV2Response): UserV2 => {
  const mflIdKey = `MFL_ID_${String(config.BASE_TENANT)}` as keyof UserInfoV2Response;
  const mflID = data[mflIdKey] as string;

  if (!mflID) {
    console.error('MFL ID not found', {data});
  }

  const dateOfBirth = moment.tz(data.Date_of_Birth, 'Australia/Sydney').toDate();

  return {
    id: mflID || '',
    firstName: data.First_Name,
    lastName: data.Last_Name,
    email: data.Email,
    dateOfBirth: dateOfBirth,
    phoneNumber: data.Mobile,
    billingAddress: {
      lines: data.Mailing_Street?.split(',') || [],
      postal_code: data.Mailing_Zip || '',
      locality: data.Mailing_City || '',
      administrative_area: data.Mailing_State || '',
    },
    zohoId: data.id,
  };
};  
